var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.237,
    height: 28.232,
    viewBox: "0 0 28.237 28.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958",
    transform: "translate(-811 -702.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14291",
    "data-name": "Path 14291",
    d: "M28.237,13.233V15c-.018.1-.04.193-.054.291-.086.589-.136,1.186-.262,1.766a13.925,13.925,0,0,1-4.682,7.81,13.721,13.721,0,0,1-6.659,3.144c-.523.091-1.051.15-1.576.223H13.24c-.345-.042-.691-.076-1.035-.128a13.849,13.849,0,0,1-9.111-5.222A13.669,13.669,0,0,1,.308,11.255,13.55,13.55,0,0,1,4.99,3.383,13.729,13.729,0,0,1,16.057.138,13.63,13.63,0,0,1,23.988,4.05a13.826,13.826,0,0,1,4.026,7.611c.092.521.15,1.048.223,1.572m-2.82.879a11.375,11.375,0,0,0-11.3-11.293A11.372,11.372,0,0,0,2.827,14.1,11.375,11.375,0,0,0,14.118,25.412a11.375,11.375,0,0,0,11.3-11.3",
    transform: "translate(811 702.565)",
    fill: "#f29e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14292",
    "data-name": "Path 14292",
    d: "M20.613,11.464h2.116v.33c0,2.233,0,4.465,0,6.7a.458.458,0,0,0,.253.458q2.922,1.737,5.833,3.492c.086.052.168.109.263.17L27.95,24.434c-.091-.052-.163-.091-.232-.133q-3.446-2.121-6.892-4.242c-.127-.078-.234-.141-.234-.329q.011-4.066.006-8.131c0-.036.007-.071.015-.136",
    transform: "translate(801.97 698.17)",
    fill: "#f29e00",
    stroke: "#f29e00",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIco);
export default __webpack_public_path__ + "static/media/time-ico.ba80928dae9d5e6f1b82d2f85eeab182.svg";
export { ForwardRef as ReactComponent };